/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GroupsInfo } from '../../models/groups-info';

export interface IlsControllerGetAllGroups$Params {
  ilsId: string;
}

export function ilsControllerGetAllGroups(http: HttpClient, rootUrl: string, params: IlsControllerGetAllGroups$Params, context?: HttpContext): Observable<StrictHttpResponse<GroupsInfo>> {
  const rb = new RequestBuilder(rootUrl, ilsControllerGetAllGroups.PATH, 'get');
  if (params) {
    rb.path('ilsId', params.ilsId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GroupsInfo>;
    })
  );
}

ilsControllerGetAllGroups.PATH = '/ils/{ilsId}/groups';
